import { Link } from 'react-router-dom';

export default function SEOContent() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16">
          {/* Left: Label */}
          <div className="lg:col-span-1">
            <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest">
              O Kakobuy Spreadsheet
            </p>
          </div>

          {/* Right: Content */}
          <div className="lg:col-span-4 space-y-8">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Czym jest <span className="text-primary-500">Kakobuy Spreadsheet</span> i dlaczego warto z niego korzystać?
            </h2>

            <div className="space-y-5 text-foreground-700 leading-relaxed">
              <p className="text-base md:text-lg">
                <strong>Kakobuy Spreadsheet</strong> to starannie opracowany arkusz kalkulacyjny zawierający setki sprawdzonych linków do produktów dostępnych na chińskich platformach zakupowych. Dzięki niemu możesz szybko znaleźć najlepsze okazje w kategoriach takich jak <strong>buty</strong>, <strong>bluzy</strong>, <strong>koszulki</strong>, <strong>kurtki</strong> czy <strong>akcesoria</strong> — bez konieczności samodzielnego przeszukiwania tysięcy ofert.
              </p>

              <p className="text-base md:text-lg">
                Nasz spreadsheet jest regularnie aktualizowany, co oznacza że zawsze masz dostęp do najświeższych linków i najlepszych cen. Każdy produkt został zweryfikowany pod kątem jakości — znajdziesz tu tylko sprawdzone oferty z pozytywnymi opiniami i zdjęciami QC.
              </p>

              <p className="text-base md:text-lg">
                Niezależnie od tego, czy dopiero zaczynasz swoją przygodę z zakupami z Chin, czy jesteś już doświadczonym kupującym — <strong>Kakobuy Spreadsheet</strong> pomoże Ci zaoszczędzić czas i pieniądze. Wszystkie linki są posegregowane według kategorii, co sprawia że nawigacja jest niezwykle intuicyjna.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-6">
              <div className="text-center p-4">
                <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500">500+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-2">Sprawdzonych linków</p>
              </div>
              <div className="text-center p-4">
                <p className="font-heading text-3xl md:text-4xl font-bold text-accent-500">14</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-2">Kategorii produktów</p>
              </div>
              <div className="text-center p-4">
                <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500">100%</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-2">Zweryfikowanych QC</p>
              </div>
              <div className="text-center p-4">
                <p className="font-heading text-3xl md:text-4xl font-bold text-accent-500">24/7</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-2">Aktualizacje</p>
              </div>
            </div>

            {/* CTA to article */}
            <div className="pt-4">
              <Link
                to="/kakobuy-spreadsheet"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-600 hover:text-primary-700 border border-primary-200 hover:border-primary-300 rounded-full transition-all duration-200 whitespace-nowrap bg-primary-50 hover:bg-primary-100 cursor-pointer"
              >
                Przeczytaj pełny poradnik
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}